


















































import Vue from 'vue'
import Component from 'vue-class-component'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import Table from '@/components/tables/Table.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import {
  IPayment,
  EAutoPayItemStatus,
  IAutoPayItem
} from '@zunta/configurations'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import { ITableConfig } from '@/interfaces'
import StatusAutoPaymentItem from '@/components/statuses/StatusAutoPaymentItem.vue'

@Component({
  components: { StatusAutoPaymentItem, AddressesPopup, Icon, DateTimeLabel, Table },
  props: {
    setting: {
      type: Object,
      required: true
    }
  }
})
export default class ResidentAutopaymentSubrow extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EAutoPayItemStatus: any = EAutoPayItemStatus

  receiptPaymentId: number = -1

  config: ITableConfig = {
    usePagination: false,
    useQuery: false,
    fetchFunction: this.fetchAutoPayItems,
    columns: [
      {
        minWidth: '100px',
        width: 17,
        key: 'amount',
        label: 'Amount Paid'
      },
      {
        minWidth: '100px',
        width: 17,
        key: 'payment-date',
        label: 'Payment Date'
      },
      {
        minWidth: '100px',
        width: 17,
        key: 'status',
        label: 'Status'
      },
      {
        minWidth: '100px',
        width: 17,
        key: 'created',
        label: 'Date created'
      },
      {
        minWidth: '100px',
        width: 17,
        key: 'updated',
        label: 'Date updated'
      },
      {
        class: 'text-right',
        minWidth: '120px',
        width: 15,
        key: 'actions'
      }
    ]
  }

  get autoPayItems () {
    return this.$store.state.payments.autoPayItems
  }

  async fetchAutoPayItems () {
    await this.paymentsModuleInstance.fetchAutoPayItems(this.$props.setting.id)
  }

  showReceipt (payment: IPayment) {
    this.receiptPaymentId = payment.id
  }

  closeReceiptPopup () {
    this.receiptPaymentId = -1
  }
}
